import assets from '../../assets';
import getExternalImages from './get-external-images';

const handleExternalImageSources = async (pasteFragment) => {
  const imagesWithExternalSources = getExternalImages(pasteFragment);
  const sources = imagesWithExternalSources.map((el) => el.src);

  if (sources.length) {
    try {
      const newSources = await assets.operations.uploadAssetsFromExternalSources(sources);
      newSources.forEach(({ externalSource, assetSource }) => {
        const pasteImg = imagesWithExternalSources.find((img) => img.src === externalSource);
        if (assetSource) {
          pasteImg.setAttribute('src', assetSource);
        } else {
          pasteImg.remove();
        }
      });
    } catch (error) {
      sources.forEach((src) => {
        const pasteImg = imagesWithExternalSources.find((img) => img.src === src);
        pasteImg.remove();
      });
    }
  }
};

export default handleExternalImageSources;
